import { render, staticRenderFns } from "./KnowledgeBaseDialogManageDoc.vue?vue&type=template&id=02f662e4&lang=pug&"
import script from "./KnowledgeBaseDialogManageDoc.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseDialogManageDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports